import AppState from "../AppState";
import { productAlertsList } from "./ProductAlertsListType";

export const selectProductAlertsListFetched = (
  state: AppState,
): productAlertsList[] => {
  return state?.productAlerts?.productAlertsList ?? [];
};
